var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0313 5.07852L13.9529 16.7027H6.04709L4.96894 5.07852L3.60278 5.1918L4.70062 17.0268C4.7584 17.5723 5.25876 18 5.84002 18H14.16C14.7411 18 15.2416 17.5726 15.3004 17.0191L16.3975 5.1918L15.0313 5.07852Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5142 2H7.48564C6.85545 2 6.34277 2.48497 6.34277 3.08109V5.13516H7.71418V3.29728H12.2856V5.13512H13.657V3.08106C13.6571 2.48497 13.1444 2 12.5142 2Z",
    fill: "#808080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3142 4.4865H2.68572C2.30697 4.4865 2 4.77687 2 5.13515C2 5.49343 2.30697 5.78381 2.68572 5.78381H17.3143C17.693 5.78381 18 5.49343 18 5.13515C18 4.77687 17.693 4.4865 17.3142 4.4865Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.d80cccacf658f4dc2afa0cce12b2be22.svg";
export { ForwardRef as ReactComponent };